import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { GetPurchaseSummaryResponse } from '@/api/handlers/resources/purchases/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { PurchaseQueryKeys } from './purchaseQueryKeys';

export const usePurchaseSummaryQuery = (enabled = true) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetPurchaseSummaryResponse>>({
        queryKey: PurchaseQueryKeys.summary(),
        queryFn: () => apiClient.purchases.getSummary(),
        enabled,
        staleTime: 60_000,
    });
};
